module.exports = __webpack_public_path__ + "media/images/icons/search-before-8134b64e5a31d364dfdf2c560fe32f7d.svg";